import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

// Approved FootPool images only. Clean 2x2 grid (Task 4).
// Alt text comes from t.gallery.alts (same order).
const GALLERY = [
  {
    src: "/images/fp-gallery-1.webp", // FP_web_0501 (assigned)
    objectPosition: "50% 50%",
  },
  {
    src: "/images/fp-gallery-2.webp", // FP_web_1001 (assigned)
    objectPosition: "50% 40%",
  },
  {
    src: "/images/fp-events-3.webp", // reuse of supplied FP_web_0601
    objectPosition: "50% 60%",
  },
  {
    src: "/images/fp-events-1.webp", // reuse of supplied FP_web_0301
    objectPosition: "50% 55%",
  },
];

export const Gallery = () => {
  const { t } = useLanguage();
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 max-w-4xl">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0055FF]">
              {t.gallery.kicker}
            </div>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold tracking-tight text-neutral-900">
              {t.gallery.title}
            </h2>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {GALLERY.map((g, i) => (
            <motion.div
              key={g.src}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.98 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              className="relative overflow-hidden rounded-3xl group aspect-[4/3]"
            >
              <img
                src={g.src}
                alt={(t.gallery.alts && t.gallery.alts[i]) || "FootPool"}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                style={g.objectPosition ? { objectPosition: g.objectPosition } : undefined}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
